export type ReportYears = {
  calendarYear: number;
  currentYear: number;
  previousYear: number;
};

export function getReportYears(date: Date = new Date()): ReportYears {
  const calendarYear = date.getFullYear();
  const currentYear = calendarYear - 1;
  const previousYear = currentYear - 1;

  return { calendarYear, currentYear, previousYear };
}

export function getSelectableReportYears(
  date: Date = new Date(),
  rangeBack: number = 5,
): number[] {
  const { currentYear } = getReportYears(date);
  return Array.from({ length: rangeBack + 1 }, (_, i) => currentYear - i);
}
